import user from './user';
import company from './company';
import staff from './staff';
import general from './general';

export default { ...company, ...user, ...staff, ...general };
